<template>
  <div class="audio-content">
    <div class="content-wrap">
      <div class="bg" />
      <div class="content">
        <div class="detail-card">
          <div class="hb-resource-cover">
            <img :src="detailData.poster" />
          </div>
          <div class="author-action">
            <div class="author">
              <span>
                {{ langTransfer("主播") }}
              </span>
              <p>
                {{ langTransfer(detailData.author) }}
              </p>
            </div>
            <div class="action">
              <img src="@/assets/img/audio/prev-black.png" @click="backAudio" />
              <img
                class="status-icon"
                :src="
                  isPlaying
                    ? require('@/assets/img/audio/pause-b.png')
                    : require('@/assets/img/audio/play-b.png')
                "
                @click="togglePlayPause"
              />
              <img src="@/assets/img/audio/next-black.png" @click="nextAudio" />
            </div>
          </div>
        </div>
        <div class="catalog-wrap">
          <div class="bread-crumb-wrap">
            <!-- 1/2/3 -->
          </div>
          <div class="info-active">
            <div class="info">
              <h5>
                {{ langTransfer(detailData.name) }}
              </h5>
              <p
                v-if="detailData.introduction"
                class="text2line"
                @click="showDialog = true"
              >
                {{ langTransfer(detailData.introduction) }}
              </p>
            </div>
            <div
              v-show="webInfo.isAllowLogin == '1' && detailData.name"
              class="add-btn-wrap lr-img-scale"
            >
              <div @click="collect">
                <LottieAddBtn
                  :is-collection="detailData.follow_state === '1'"
                />
              </div>
            </div>
          </div>
          <div class="list-header">
            <p>
              {{ langTransfer("播放列表") }}
            </p>
            <p>
              {{ langTransfer(`${listData.length}条音频`) }}
              <span>{{
                langTransfer(`共${listTime[0] || 0}分${listTime[1] || 0}秒`)
              }}</span>
            </p>
          </div>
          <div class="list-wrap">
            <bscroll-view>
              <div class="list-content">
                <div
                  v-for="(item, index) in listData"
                  :key="index"
                  class="item"
                  :class="{ 'is-playing-item': listIndex === index }"
                  @click="audioClick(index)"
                >
                  <img
                    :src="
                      isPlaying
                        ? require('@/assets/img/audio/pause-black.png')
                        : require('@/assets/img/play-black.png')
                    "
                  />
                  <i>
                    {{ `0${index + 1}`.substr(-2) }}
                  </i>
                  <p class="text1line">
                    {{ langTransfer(item.title) }}
                  </p>
                  <span>
                    {{ countTime(item.duration) }}
                  </span>
                </div>
              </div>
            </bscroll-view>
          </div>
        </div>
        <!-- <div class="qrcode-popover"> -->
        <el-popover
          v-show="qrcodeObj"
          placement="top-start"
          trigger="hover"
          :offset="0"
          popper-class="qrcode-popover"
        >
          <div class="common-qrcode-content">
            <div ref="qrcode" />
          </div>
          <img
            slot="reference"
            class="common-qrcode-popover"
            src="@/assets/img/qrcode.png"
          />
        </el-popover>
        <!-- </div> -->
      </div>
    </div>
    <div class="audio-player-wrap">
      <audio
        ref="audio"
        controls="controls"
        style="opacity: 0; width: 0.1px; height: 0.1px"
        @timeupdate="audioTimeUpdate()"
        @loadedmetadata="getAudioLength()"
      >
        <source :src="audioUrl" type="audio/ogg" />
        <source :src="audioUrl" type="audio/mpeg" />
      </audio>
      <div class="audio-player">
        <div class="action">
          <img src="@/assets/img/audio/prev.png" @click="backAudio" />
          <img
            class="status-icon"
            :src="
              isPlaying
                ? require('@/assets/img/audio/pause-black.png')
                : require('@/assets/img/play-black.png')
            "
            @click="togglePlayPause"
          />
          <img src="@/assets/img/audio/next.png" @click="nextAudio" />
        </div>
        <div class="name-progress">
          <div class="name-time">
            <p>{{ langTransfer(`正在播放:${bottit}`) }}</p>
            <p>
              {{ countTime(currentTime) || "00:00" }} /
              {{ countTime(audioLength) || "00:00" }}
            </p>
          </div>
          <div class="progress">
            <el-slider
              v-model="currentTime"
              :show-tooltip="false"
              :max="audio.duration"
              @change="changeCurrentTime"
            />
          </div>
        </div>
        <div class="volume">
          <img src="@/assets/img/audio/volume.png" />
          <el-slider v-model="ylvalue" width="100px" />
        </div>
      </div>
    </div>
    <el-dialog
      width="820px"
      class="common-custom-dialog"
      :visible.sync="showDialog"
      :show-close="false"
    >
      <div class="dialog-content-wrap">
        <div class="close">
          <img src="@/assets/img/close.png" @click="showDialog = false" />
        </div>
        <div class="texts-wrap">
          <h5>
            {{ langTransfer(detailData.name) }}
          </h5>
          <p class="summary">
            {{ langTransfer(detailData.introduction) }}
          </p>
        </div>
      </div>
    </el-dialog>
    <!-- <pagination /> -->
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import BscrollView from "@/components/bscrollView";
import LottieAddBtn from "@/components/lottieActions/add";
import {
  detail,
  audioCatalogList,
  qrCode,
  icityCollect,
} from "../../api/lyl";

export default {
  name: "Home",
  components: {
    BscrollView,
    LottieAddBtn,
  },
  data() {
    return {
      showDialog: false,
      bottit: "",
      detailData: [],
      currentTime: 0,
      listData: "",
      // 当前播放
      audioUrl: "",
      // 是否播放
      isPlaying: !true,
      // 音量参数
      ylvalue: 100,
      // 时间进度条
      value3: 0,
      ylShow: false,
      // 点击样式切换
      listIndex: 0,
      // 音频
      audio: "",
      //标记时间戳
      lastTime: null,
      //audio时长
      audioLength: 0,
      // 总时间
      listTime: [],
      qrcodeObj: undefined,
      audioInfoList: {}, //当前播放音乐
      breadcrumbData: [],
    };
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
  },
  watch: {
    ylvalue(v) {
      this.audio.volume = v * (0.01).toFixed(3);
    },
    audioUrl() {
      this.audio.load();
    },
  },
  mounted() {
    const { service_code } = this.webInfo;
    if (service_code) {
      // 目录
      // this.audioCatalogList();
      // 详情
      this.detail();
      this.getQrcode();
    }
    this.Request_baseURL = Request.baseURLDataval;

    // 音频ID
    this.audio = this.$refs.audio;

  },
  methods: {
    initQrCode(text) {
      const ele = this.$refs.qrcode;
      ele.innerHTML = "";
      this.qrcodeObj = new QRCode(ele, {
        width: 110,
        height: 110,
        text,
      });
    },
    async getQrcode() {
      try {
        const { id } = this.$route.params;
        const data = await qrCode({
          type: 4,
          service_code: this.webInfo.service_code,
          id,
          user_unique_code: this.user_unique_code,
        });
        this.initQrCode(data);
      } catch (err) {
        console.log(err);
      }
    },
    collectCollect(e) {
      let program_id = this.listData[e].order_number == undefined ? null : this.listData[e].order_number;
      let program_name = this.listData[e].title == undefined ? null : this.listData[e].title;
      icityCollect({
        serviceCode: this.webInfo.service_code,
        // type: 22,
        resourceCode: this.detailData.id,
        resourceName: this.detailData.name,
        programId: program_id,
        programName: program_name,
        // author: this.detailData.author,
        platformName:'精品阅览室pc端',
        resourceType:4,
        operationType:1
      });
    },
    // 列表
    async detail() {
      try {
        const { id } = this.$route.params;
        const data = await detail({
          service_code: this.webInfo.service_code,
          type: "4",
          id,
          user_unique_code: this.user_unique_code,
        });
        this.detailData = data;
        this.initBreadcrumbData();// 目录
        this.audioCatalogList()
      } catch (err) {
        console.log(err);
      }
    },
    // 目录
    async audioCatalogList() {
      try {
        const { id } = this.$route.params;
        const data = await audioCatalogList({
          service_code: this.webInfo.service_code,
          id,
        });
        this.audioUrl = data[0].link_url;
        this.bottit = data[0].title;
        [this.audioInfoList] = data;
        this.listData = data;
        this.collectCollect(0)
        // 音频时间
        this.listTimeFun();
      } catch (err) {
        console.log(err);
      }
    },
    //更新视频时间。节流，每秒触发一次
    audioTimeUpdate() {
      const nowTime = Date.now();
      const gapTime = 1000;
      if (!this.lastTime || nowTime - this.lastTime > gapTime) {
        if (this.$refs.audio) {
          const time = this.$refs.audio.currentTime;
          this.currentTime = time;
        }
        this.lastTime = nowTime;
      }
    },
    getAudioLength() {
      this.audioLength = this.$refs.audio.duration;
    },
    //改变视频时间
    changeCurrentTime(val) {
      if (this.$refs.audio) {
        this.$refs.audio.currentTime = val;
      }
    },
    togglePlayPause() {
      if (this.isPlaying) {
        this.notAudio();
      } else {
        this.playAudio();
      }
    },
    // 开始播放
    playAudio() {
      this.isPlaying = true;
      this.audio.play();
      this.$sta.staAdmin({
        oprate_type: "收听",
        resource_type: "音频",
        module_name: "音频详情",
        content_type: "音频详情",
        resource_id: this.$route.query.id,
        resource_name: this.detailData.name,
        content_id: this.audioInfoList.id,
        content_name: this.audioInfoList.title,
        author: this.detailData.author,
        // year:data.year,
        // issue:data.issue,
      });
    },
    // 停止播放
    notAudio() {
      this.isPlaying = false;
      this.audio.pause();
      // 清除定时器
      clearInterval(this.audioInterval);
    },
    // 上一首
    backAudio() {
      if (this.listIndex < 1) {
        return;
      }
      this.listIndex -= 1;
      this.audioUrl = this.listData[this.listIndex].link_url;
      this.bottit = this.listData[this.listIndex].title;
      this.audioInfoList = this.listData[this.listIndex];
      this.audio.load();
      this.$nextTick(() => {
        this.playAudio();
      });
    },
    // 下一首
    nextAudio() {
      if (this.listIndex >= this.listData.length - 1) {
        return;
      }
      this.listIndex += 1;
      this.audioUrl = this.listData[this.listIndex].link_url;
      this.bottit = this.listData[this.listIndex].title;
      this.audioInfoList = this.listData[this.listIndex];
      this.audio.load();
      this.$nextTick(() => {
        this.playAudio();
      });
    },
    // 点击列表
    audioClick(i) {
      this.collectCollect(i);
      this.listIndex = i;
      this.audioUrl = this.listData[this.listIndex].link_url;
      this.bottit = this.listData[this.listIndex].title;
      this.audioInfoList = this.listData[this.listIndex];
      this.audio.load();
      this.$nextTick(() => {
        this.playAudio();
      });
    },
    formatTooltip(val) {
      return val / 100;
    },
    // 时间转换
    countTime(val) {
      if (!val) {
        return "00:00:00";
      }
      let h;
      let m;
      let s;
      if (val >= 0) {
        h = Math.floor(val / 60 / 60);
        m = Math.floor((val / 60) % 60);
        s = Math.floor(val % 60);
        if (s < 10) {
          s = `0${s}`;
        }
        if (m < 10) {
          m = `0${m}`;
        }
        if (h < 10) {
          h = `0${h}`;
        }
      } else {
        return false;
      }
      return `${h}:${m}:${s}`;
    },
    collect() {
      const { id: res_code } = this.$route.params;
      const formData = {
        type: 10,
        res_code,
        user_unique_code: this.user_unique_code,
      };
      const callback = (bool) => {
        if (bool) {
          this.detailData.follow_state = "2";
        } else {
          this.detailData.follow_state = "1";
        }
      };
      this.$utils.userCollect(formData, callback);
    },
    // 音频时间
    listTimeFun() {
      let num = 0;
      this.listData.map((item) => {
        num += Number(item.duration);
      });
      const numfu = this.secondToDate(num);
      this.listTime = numfu.split(":");
    },
    // 时间转换
    secondToDate(val) {
      // var h = Math.floor(val / 3600),
      const m = Math.floor(val / 60);
      const s = Math.floor(val % 60);
      //自己判断了...
      return `${m}:${s}`;
    },
    initBreadcrumbData() {
      const { query } = this.$route;
      if (!query.p1FullPath || !query.p0FullPath) {
        return;
      }
      this.breadcrumbData = [
        {
          path: query.p1FullPath,
          name: query.p1Name,
        },
        {
          path: query.p0FullPath,
          name: query.p0Name,
        },
        {
          name: this.detailData.name || "音频详情",
        },
      ];
    },
  },
};
</script>

<style scoped lang="less">
.audio-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.content-wrap {
  width: 100%;
  flex: 1;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;

  .bg {
    width: calc(50% - 240px);
    height: 100%;
    background: #e4e7ed;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
.content {
  width: 1200px;
  height: 100%;
  box-sizing: border-box;
  padding-top: 46px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  z-index: 1;

  .detail-card {
    width: 480px;
    height: 548px;
    box-sizing: border-box;
    padding: 30px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 10000px) {
      .hb-resource-cover {
        width: 420px;
        height: 420px;
      }
    }
    @media screen and (max-width: 1280px) {
      .hb-resource-cover {
        width: 340px;
        height: 340px;
      }
    }
    .hb-resource-cover {
      border-radius: 8px;
      cursor: default;
    }

    .author-action {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .author {
      max-width: 280px;

      span {
        display: block;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
      }

      p {
        margin-top: 4px;
        font-size: 24px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        line-height: 24px;
      }
    }

    .action {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
        user-select: none;
      }

      .status-icon {
        width: 48px;
        height: 48px;
        box-sizing: border-box;
        padding: 6px;
        margin: 0 12px;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 50%;
      }
    }
  }

  .catalog-wrap {
    width: 660px;
    height: 100%;
    box-sizing: border-box;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .bread-crumb-wrap {
    font-size: 13px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .info-active {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
  }

  .info {
    width: 504px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    h5 {
      font-size: 36px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      line-height: 36px;
    }

    p {
      max-height: 40px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 20px;
      margin-top: 10px;
    }
  }

  .add-btn-wrap {
    width: 80px;
    height: 36px;
    background: #303133;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 18px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}

.list-header {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 20px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 12px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    line-height: 20px;
  }

  span {
    margin-left: 4px;
  }
}

.list-wrap {
  width: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.list-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-bottom: 30px;

  .item {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;

    i {
      display: block;
      width: 60px;
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      text-align: center;
      font-style: normal;
    }

    img {
      width: 24px;
      height: 24px;
      margin: 0 18px;
      display: none;
    }

    p {
      flex: 1;
      margin: 0 10px;
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
    }

    span {
      display: block;
      width: 80px;
      font-size: 12px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 24px;
      margin-right: 20px;
      text-align: right;
    }
  }

  .is-playing-item {
    background: #f5f7fa;

    i {
      display: none;
    }

    img {
      display: block;
    }
  }
}

.audio-player-wrap {
  width: 100%;
  height: 60px;
  background: #303133;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  position: relative;

  audio {
    position: absolute;
    opacity: 0;
    width: 0.1px;
    height: 0.1px;
  }
}

.audio-player {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .action {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
      user-select: none;
    }

    .status-icon {
      width: 36px;
      height: 36px;
      background: #ffffff;
      border-radius: 50%;
      box-sizing: border-box;
      padding: 6px;
      margin: 0 12px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    }
  }

  .name-progress {
    flex: 1;
    margin: 0 62px 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;

    .name-time {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      p {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 12px;
      }
    }

    .progress {
      width: 100%;
    }
  }

  .volume {
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    img {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }

    .el-slider {
      width: 100px;
    }
  }
}

.dialog-content-wrap {
  .close {
    width: 100%;
    height: 36px;
    background: #f5f7fa;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .texts-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 40px 40px 94px;
  }

  h5 {
    width: 100%;
    height: 24px;
    font-size: 24px;
    font-family: AlibabaPuHuiTiB;
    color: #000000;
    line-height: 24px;
    margin-bottom: 20px;
  }

  .summary {
    width: 100%;
    font-size: 15px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    line-height: 24px;
  }
}
</style>

<style lang="less">
.progress .el-slider__runway {
  height: 4px;
  margin: 0 !important;
  background: #909399;
}
.progress .el-slider__bar {
  height: 4px;
  margin: 0 !important;
  background: #f5f7fa;
}

.progress .el-slider__button-wrapper {
  top: -16px;
}

.progress .el-slider__button {
  width: 14px;
  height: 14px;
  background: #fff;
  border: none;
}

.volume .el-slider__runway {
  height: 4px;
  margin: 0 !important;
  background: #909399;
}
.volume .el-slider__bar {
  height: 4px;
  margin: 0 !important;
  background: #f5f7fa;
}

.volume .el-slider__button-wrapper {
  top: -16px;
}

.volume .el-slider__button {
  width: 12px;
  height: 12px;
  background: #fff;
  border: none;
}
</style>
